import {Components} from '@buncha/localization/types';
import CustomLoader from './CustomLoader';
import {CustomText} from '../../core/text';
import If from '../../conditional/If';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';

import {useColorThemeType} from '@buncha/appStyles/hooks/theme';
import font from '@buncha/appStyles/style/font';
import {useGetLocale} from '@buncha/localization/hooks';
import {Box, HBox} from '../../core/view';

const LoaderComponents = (props: {showBottomText: boolean}) => {
  const theme = useColorThemeType();
  const {body} = useGetLocale(Modules.components, Components.components) ?? {};

  return (
    <Box style={[styles.parentContainer]}>
      <HBox style={[styles.loaderContainer]}>
        <CustomLoader />
      </HBox>
      <If condition={props.showBottomText}>
        <HBox style={[styles.TypoContainer]}>
          <CustomText style={{color: theme?.text.gray[100]}}>
            {body?.loaderComponents?.[0]}
            <CustomText
              style={[styles.boldFont, {color: theme?.text.gray[100]}]}>
              {body?.loaderComponents?.[1]}
            </CustomText>
            {body?.loaderComponents?.[2]}
            <CustomText
              style={[styles.boldFont, {color: theme?.text.gray[100]}]}>
              {body?.loaderComponents?.[3]}
            </CustomText>
            {body?.loaderComponents?.[4]}
          </CustomText>
        </HBox>
      </If>
    </Box>
  );
};

export default React.memo(LoaderComponents);

const styles = StyleSheet.create({
  parentContainer: {
    flex: 1,
    flexGrow: 1,
    justifyContent: 'center',
  },
  loaderContainer: {
    justifyContent: 'center',
  },
  TypoContainer: {
    // width: Dimensions.get('screen').width * 0.9,
    justifyContent: 'center',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  boldFont: {
    fontFamily: font.fontTheme.muli[700].normal,
  },
});
